import Header from "../pages/Header";
import Footer from "./Footer";
import styles from "../pages/TermsofUse.module.css";
import logo from "../media/cart7_logo_black.png";

function Shipping () {
  return(
    <>
    <Header />
    <div className={styles.fullWrapper}>
      <div className={styles.container}>
        <div  className={styles.logo}><img src={logo} alt="logo" /></div>
        <h2>Shipping Policy</h2>

<h3>Last Updated: [14 March 2026]</h3>

This Shipping Policy explains how orders are processed and delivered.

<h3>1. Order Processing</h3>

Orders are usually processed within [1-3 business days] after payment confirmation.

<h3>2. Delivery Time</h3>

Delivery times may vary depending on your location. Estimated delivery time is typically [1-4 business days].

Please note that delays may occur due to courier services, weather conditions, or other unforeseen circumstances.

<h3>3. Shipping Charges</h3>

Shipping charges, if applicable, will be displayed during checkout before completing your order.

<h3>4. Delivery Issues</h3>

If you experience any issues with delivery or tracking, please contact us through WhatsApp support available on the website.

<h3>5. Incorrect Address</h3>

Customers are responsible for providing accurate shipping details. We are not responsible for delivery issues caused by incorrect address information.
      </div>
    </div>
    <Footer />
    </>
    );
}
export default Shipping;